var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.printCV()}}},[_c('div',{staticClass:"xhani"})])
}
var staticRenderFns = []

export { render, staticRenderFns }